import { OccasionsEnum } from '@/types/bundles.types';
import { Promotion, PromotionData, PromotionStatusGroup } from '@/types/promotions.types';
import { TFunction } from 'i18next';

export function filterOccasion(occasions: OccasionsEnum[], filterValue: any): boolean {
  const rowOccasionList = occasions?.join(', ') || '';
  const modifiedFilterValue = filterValue.replace(/-/g, '_');
  if (rowOccasionList.includes(modifiedFilterValue.toUpperCase())) return true;
  if (rowOccasionList.includes(modifiedFilterValue.toLowerCase())) return true;

  const filterValueIsAll =
    modifiedFilterValue.toLowerCase() === 'a' ||
    modifiedFilterValue.toLowerCase() === 'al' ||
    modifiedFilterValue.toLowerCase() === 'all';
  const occasionsListIsAll =
    occasions?.length === 0 ||
    (rowOccasionList.includes('CARRYOUT') &&
      rowOccasionList.includes('DELIVERY') &&
      rowOccasionList.includes('DRIVE_THRU') &&
      rowOccasionList.includes('DINE_IN'));
  if (occasionsListIsAll && filterValueIsAll) return true;
  return false;
}

export function filterOccasions(promotion: Promotion, filterValue: any): boolean {
  return filterOccasion(promotion.occasions, filterValue);
}

//for Admin mock data
export function filterPromotionOccasions(promotion: PromotionData, filterValue: any): boolean {
  return filterOccasion(promotion.occasions, filterValue);
}

export function filterNumbers(num: number, filterValue: string): boolean {
  return num?.toString().includes(filterValue) || false;
}
export function filterBooleans(bool: boolean, filterValue: any): boolean {
  const filterValueIsYes =
    filterValue.toLowerCase() === 'y' || filterValue.toLowerCase() === 'ye' || filterValue.toLowerCase() === 'yes';
  const filterValueIsNo = filterValue.toLowerCase() === 'n' || filterValue.toLowerCase() === 'no';
  if (filterValueIsYes && bool) return true;
  if (filterValueIsNo && !bool) return true;
  return false;
}

export function filterRedemptionCodes(promotion: Promotion, filterValue: string): boolean {
  if (
    promotion.redemptionCodes.join(', ').includes(filterValue.toUpperCase()) ||
    promotion.redemptionCodes.join(', ').includes(filterValue.toLowerCase()) ||
    (promotion.redemptionCodes.length < 1 && filterValue.includes('-'))
  ) {
    return true;
  }
  return false;
}

export const identicalArrays = (originalData: PromotionData[], currentData: PromotionData[]) => {
  let identicalData = true;
  const stringToBoolean = (string: string | boolean) => (string === 'false' ? false : !!string);
  if (currentData === originalData) {
    identicalData = true;
  }
  if (currentData.length !== originalData.length) {
    return false;
  }
  for (let i = 0; i < currentData.length; i += 1) {
    const newBoolean = stringToBoolean(currentData[i].isLock);
    if (newBoolean !== originalData[i].isLock) {
      return false;
    }
  }
  return identicalData;
};

export const identicalArraysForPromotionSettings = (
  originalData: PromotionStatusGroup[],
  currentData: PromotionStatusGroup[],
) => {
  let identicalData = true;
  if (currentData === originalData) {
    identicalData = true;
  }
  if (currentData.length !== originalData.length) {
    return false;
  }
  for (let i = 0; i < currentData.length; i += 1) {
    if (currentData[i].status !== originalData[i].status) {
      return false;
    }
  }
  return identicalData;
};

export function getColumnDefinition(t: TFunction, showUpchargeColumn: boolean) {
  const columns = [
    { accessorKey: 'effectType', header: t('promotions.table.effectType'), enableSorting: true },
    {
      accessorKey: 'pricingEffectType',
      header: t('promotions.table.pricingEffectType'),
      enableSorting: true,
    },
  ];

  if (showUpchargeColumn) {
    columns.push({ accessorKey: 'priceOrDiscount', header: t('promotions.table.upcharge'), enableSorting: true });
  } else {
    columns.push({
      accessorKey: 'priceOrDiscount',
      header: t('promotions.table.priceDiscount'),
      enableSorting: true,
    });
  }
  columns.push({ accessorKey: 'options', header: t('promotions.table.options'), enableSorting: true });

  return columns;
}
